<template>
    <vue-topprogress ref="topProgress" color="#4ab975"></vue-topprogress>
</template>

<script>
import { vueTopprogress } from "vue-top-progress";
export default {
    name: "Loader",
    props: {
        loading: Boolean
    },
    components: {
        vueTopprogress
    },
    watch: {
        loading(value) {
            if (!value) {
                this.$refs.topProgress.done();
            } else {
                this.$refs.topProgress.start();
            }
        }
    }
};
</script>
<style scoped>
.loader-container {
    display: none;
}
.loader-show {
    z-index: 99999;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 1);
}
</style>
